import { container } from 'hoc'
import Component from './button'

const mapStore = (store, { name, onClick }) => {
  return {
    onClick: (e) => {
      store.dispatch({ type: `@@ui/BUTTON/${name}`, payload: name })
      if (onClick) onClick(e)
    },
  }
}

export default container({ mapStore })(Component)
